var map = {
	"./pexels-alexander-ant-4585185.jpg": "ea33",
	"./pexels-alexander-ant-7004737.jpg": "4b16",
	"./pexels-maria-pashkova-8943321.jpg": "4613",
	"./pexels-nothing-ahead-7036435.jpg": "4cc7",
	"./pexels-steve-johnson-1572386.jpg": "681b",
	"./pexels-steve-johnson-1606591.jpg": "ce20",
	"./pexels-thirdman-6732658.jpg": "134b",
	"./upload-img.png": "6712"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f81";